import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import ComponentSlider from "src/mtska-frontend-app-component/components/Slider/ComponentSlider";
import { Button } from 'src/mtska-frontend-app-component';
import { useSettingContextInComponent, useSyncDashboardFullscreenClass } from "src/mtska-frontend-app-scaffolding";
import { getBiIntegratedReportTitle, resolveBiIntegratedReport } from './reportResolver';
import { useDashboardReportConfiguration } from 'src/mtska-frontend-modules/modules/_shared/dashboardFilters/useDashboardReportConfiguration';

const KEY_PREFIX = 'biint';

const Container = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    useSyncDashboardFullscreenClass();
    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const { reportConfiguration } = useDashboardReportConfiguration();
    const showKPI = true;

    const mergedFilters = filterModel ?? defaultFilters;

    const report = resolveBiIntegratedReport({
        t,
        filters: mergedFilters,
        keyPrefix: KEY_PREFIX,
        filtersStorageKey: dataProviderName,
        reportConfiguration,
    });
    const reportTitle = getBiIntegratedReportTitle(reportConfiguration);

    return (
        <Box className="mtska-dashboard-container" sx={{ position: "relative" }}>
            {showKPI &&
                <Box className="dashboard-section-title" sx={{ marginTop: '30px', marginBottom: '10px' }}>
                    <h2>{t(reportTitle)}</h2>
                </Box>
            }

            <ComponentSlider report={report} />

            <Box className="mtska-fullscreen-toggle">
                <Button
                    variant="soft"
                    size="sm"
                    icon="faExpand"
                    onClick={() => {
                        const parent = document.querySelector('.mtska-dashboard-container');
                        if (!parent) return;
                        if (document.fullscreenElement || document.webkitFullscreenElement) {
                            parent.classList.remove('mtska-fullscreen');
                            if (document.exitFullscreen) {
                                document.exitFullscreen();
                            } else if (document.webkitExitFullscreen) {
                                document.webkitExitFullscreen();
                            }
                        } else {
                            if (parent.requestFullscreen) {
                                parent.requestFullscreen()
                                    .then(() => parent.classList.add('mtska-fullscreen'))
                                    .catch(() => parent.classList.remove('mtska-fullscreen'));
                            } else if (parent.webkitRequestFullscreen) {
                                parent.webkitRequestFullscreen();
                                parent.classList.add('mtska-fullscreen');
                            }
                        }
                    }}
                    aria-label={t('Fullscreen')}
                />
            </Box>
        </Box>
    )
}

export default Container;
